<template>
  <div :class="['pdf-container', { 'in-dialog': isInDialog }]">
    <div>
      <!--  主要部分   -->
      <div
        class="right-preview"
        :class="{ 'dialog-mode': isInDialog }"
        :style="{
          'margin-right': isInDialog
            ? '0'
            : isPrintMode
            ? '0px; width:100%;'
            : isViewMode && !isAssign
            ? '10px'
            : '250px'
        }">
        <el-row :hidden="isPrintMode" :gutter="20">
          <!-- 頂部功能列 -->
          <div id="topbar" class="action-bar" :style="{ 'text-align': 'left', display: 'flex' }">
            <span class="bar-btn" @click="handleBack">
              <i class="el-icon-back rect"> 返回 </i>
            </span>
            <!-- 檢視/分配模式下的下載與列印按鈕（字段設計模式不顯示） -->
            <template v-if="isViewMode || isAssign">
              <span class="bar-btn" @click="handleDownload">
                <i class="el-icon-download rect"> 下載 </i>
              </span>
              <span class="bar-btn" @click="handlePrint">
                <i class="el-icon-printer rect"> 列印 </i>
              </span>
            </template>
            <!-- 編輯模式下的功能按鈕 -->
            <div v-if="isViewMode === false">
              <span class="bar-btn" @click="handleSave">
                <i class="el-icon-document-checked rect"> 儲存 </i>
              </span>
              <span class="bar-btn" title="復原上一步" data-action="undo" @click="handleEditor('under')">
                <i class="el-icon-refresh-left rect"> 復原 </i>
              </span>
              <span class="bar-btn" title="重做下一步" data-action="redo" @click="handleEditor('redo')">
                <i class="el-icon-refresh-right rect"> 重做 </i>
              </span>
              <span class="bar-btn" title="刪除選中組件" data-action="delete" @click="handleEditor('delete')">
                <i class="el-icon-delete rect"> 刪除 </i>
              </span>
              <span class="bar-btn" title="清空所有組件" data-action="clear" @click="handleEditor('clear')">
                <i class="el-icon-brush rect"> 清空 </i>
              </span>
            </div>
          </div>
        </el-row>

        <el-row :gutter="20">
          <!-- PDF文件顯示區域 -->
          <div class="center-board" :style="isPrintMode ? 'width:100%' : 'width:auto'">
            <!-- PDF頁碼顯示 -->
            <div
              v-if="numPages > 0 && isPrintMode === false"
              class="top-pdf-bar"
              :style="'width:' + showpdfwidth + 'px'">
              <div style="width: 100px" />
              <div style="width: 100%; text-align: center">
                <el-input v-model.number="page" type="number" size="mini" style="width: 70px" />
                <span style="color: white; font-size: 14px">&nbsp;/&nbsp;{{ numPages }}</span>
              </div>
              <div style="width: 100px" />
            </div>

            <!-- PDF載入狀態顯示 -->
            <div
              id="pdfContainer"
              v-loading="(selPdfPath !== '' && numPages <= 0) || curLoadedPage < numPages || isSaveData">
              <!-- PDF渲染區域 -->
              <div
                id="pdfvuer"
                ref="pdfvuer"
                class="result-wrapper"
                :style="
                  isPrintMode
                    ? 'position:initial;width:100' + '%;overflow:hidden;'
                    : numPages <= 0
                    ? 'border:none'
                    : 'border:none;width:' + showpdfwidth + 'px'
                ">
                <!-- PDF 顯示層 -->
                <div id="pdfLayer" ref="pdfLayer" style="position: absolute; width: 100%">
                  <PDF
                    v-for="index in numPages"
                    :id="index"
                    :key="index"
                    :src="pdfdata"
                    class="pdf-view"
                    :class="{ 'last-page': index === numPages }"
                    :page="index"
                    @page-loaded="pageLoaded"
                    @error="error"
                    @link-clicked="handle_pdf_link" />
                </div>
                <!-- 簽名字段框 編輯層（已簽署文件不顯示控件） -->
                <div
                  v-if="shouldShowControls"
                  id="placeholderLayer"
                  :key="placeholderKey"
                  ref="placeholderLayer"
                  :hidden="numPages <= 0 || curLoadedPage < 1"
                  :style="{ position: 'absolute' }">
                  <PDFCanvas
                    ref="vseditor"
                    :style="{ width: pdfWidth + 'px', height: pdfHeight + 'px' }"
                    :initial-p-d-f-controls="docData.SIGN_DATA"
                    :pdf-width="pdfWidth"
                    :pdf-height="pdfHeight" />
                </div>
              </div>
            </div>
          </div>
        </el-row>
      </div>

      <!-- 簽名元件面板(字段設計時顯示) -->
      <div v-if="isViewMode === false" :hidden="isPrintMode" class="right-board">
        <el-card :body-style="{ padding: '5px', paddingTop: '10px' }">
          <span style="display: flex; justify-content: center; margin-bottom: 5px">項目</span>
          <el-tabs>
            <el-tab-pane label="主要簽署者">
              <ComponentsVue type="Main Signer" />
            </el-tab-pane>
            <el-tab-pane label="醫生">
              <ComponentsVue type="Doctor" />
            </el-tab-pane>
            <el-tab-pane label="證人1">
              <ComponentsVue type="Witness1" />
            </el-tab-pane>
            <el-tab-pane label="證人2">
              <ComponentsVue type="Witness2" />
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>

      <!-- 分配文件面板(指派文件時顯示) -->
      <div v-if="isAssign" :hidden="isPrintMode" class="right-board-assign">
        <el-card :body-style="{ padding: '10px', paddingTop: '30px' }">
          <div style="display: flex">
            <span style="font-size: 12px; display: flex; align-items: center">這個文檔將在</span>
            <el-input-number
              v-model="deadline_days"
              controls-position="right"
              size="small"
              style="width: 95px; margin: 0 5px"
              :min="1"
              @change="handleDeadlineChange"></el-input-number>
            <span style="font-size: 12px; display: flex; align-items: center">天後到期</span>
          </div>
          <div style="display: flex; margin-top: 15px">
            <span style="color: gray; font-size: 11px; display: flex; align-items: center"
              >到期日為：{{ deadline_date1 | parseTime('{y}-{m}-{d}') }}</span
            >
          </div>
          <div style="text-align: center; margin-top: 30px">
            <el-button type="primary" @click="assignDocument">指派</el-button>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 字段名稱設定對話框 -->
    <el-dialog :visible.sync="fieldNameDialogVisible" :close-on-click-modal="false" width="600px">
      <el-form
        ref="formRef"
        class="dialog-from-margin"
        :rules="rules"
        status-icon
        :model="control"
        label-position="top">
        <el-form-item label="字段名稱：" prop="fieldname">
          <el-input v-model="control.fieldname" clearable show-word-limit placeholder="請輸入字段名稱" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fieldNameDialogVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="handleSetFieldName"> 確定 </el-button>
      </div>
    </el-dialog>

    <!-- 關係設定對話框 -->
    <el-dialog :visible.sync="relationshipDialogVisible" :close-on-click-modal="false" width="400px">
      <el-form
        ref="rformRef"
        class="dialog-from-margin"
        :rules="rules"
        status-icon
        :model="control"
        label-position="left"
        label-width="120px">
        <el-form-item label="姓名：" prop="signername">
          <el-input v-model="control.signername" clearable show-word-limit placeholder="請輸入" />
        </el-form-item>
        <el-form-item label="與病患的關係：" prop="relationship">
          <el-input v-model="control.relationship" clearable show-word-limit placeholder="請輸入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="relationshipDialogVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="handleSetRelationship"> 確定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PDFDocument } from 'pdf-lib'
import { updateDocHistory } from '@/api/docshistory'
import PDF from 'vue-pdf'
import PDFCanvas from '@/placeholders/vseditor/index'
import ComponentsVue from '@/placeholders/vseditor/components.vue'
import request from '@/utils/request'
import {
  EVENT_APPLICATION_CLEAR,
  EVENT_APPLICATION_REDO,
  EVENT_APPLICATION_UNDO,
  EVENT_COMPONENT_DELETE,
  EVENT_COMPONENT_DUPLICATE
} from '@/placeholders/vseditor/event-enums'

export default {
  name: 'PDFWorkspace',
  components: {
    PDF,
    PDFCanvas,
    ComponentsVue
  },
  props: {
    // PDF文檔數據
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    // 是否為檢視模式
    isViewMode: {
      type: Boolean,
      default: false
    },
    // 是否為分配模式
    isAssign: {
      type: Boolean,
      default: false
    },
    // 是否為列印模式
    isPrintMode: {
      type: Boolean,
      default: false
    },
    // 是否在 Dialog 中顯示
    isInDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      key: +new Date(),
      // 文檔相關資料
      docData: {
        ID: undefined,
        PATIENT_DATA: undefined, // 病患資料
        SIGN_DATA: undefined // 簽名區位置資料
      },
      deadline_days: 1,
      selPdfPath: '',
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: 'page-width',
      curLoadedPage: 0,

      // PDF尺寸資訊
      pdfWidth: 0,
      pdfHeight: 0,
      placeholderKey: +new Date(),

      isLoadedPdf: false,
      isLoadedDesign: false,

      isSaveData: false,
      // Blob URL 用於記憶體管理
      blobUrl: null,
      realpdfwidth: 0,
      realpdfheight: 0,
      showpdfwidth: 0,
      PAGE_MARGIN: 16, // PDF 頁面間距（與 CSS margin-bottom 保持同步）

      // 對話框顯示狀態
      fieldNameDialogVisible: false,
      relationshipDialogVisible: false,
      item: undefined,
      control: {
        fieldname: '',
        signername: '',
        relationship: ''
      },

      // 表單驗證規則
      rules: {
        fieldname: [{ required: true, message: '請輸入', trigger: 'blur' }],
        signername: [{ required: true, message: '請輸入', trigger: 'blur' }],
        relationship: [{ required: true, message: '請輸入', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['USERNAME']),
    formattedZoom() {
      return parseInt(this.scale * 100, 10)
    },
    // 計算截止日期
    deadline_date() {
      const d = new Date()
      d.setDate(d.getDate() + this.deadline_days)
      return d
    },
    deadline_date1() {
      const d = new Date()
      d.setDate(d.getDate() + this.deadline_days - 1)
      return d
    },
    // 判斷是否應該顯示控件層
    // 已簽署文件（TEMPLATE_PATH 包含 /signed/）不顯示控件
    shouldShowControls() {
      // 如果是已簽署文件（路徑包含 /signed/），不顯示控件
      if (this.data.TEMPLATE_PATH && this.data.TEMPLATE_PATH.includes('/signed/')) {
        return false
      }
      // 設計模式下，即使沒有 SIGN_DATA 也要顯示控件層（允許新增字段）
      if (this.isViewMode === false) {
        return true
      }
      // 檢視模式下，根據 SIGN_DATA 是否存在來決定
      return this.docData.SIGN_DATA && this.docData.SIGN_DATA.length > 0
    }
  },
  watch: {
    // 監聽頁碼變更並處理頁面捲動
    page: function (p) {
      if (p <= 1) {
        this.page = 1
        p = 1
      } else if (p > this.numPages) {
        this.page = this.numPages
        p = this.numPages
      }

      const firstPos = this.findPos(document.getElementById(1))
      const halfHeight = document.getElementById(1).clientHeight / 2 - 50
      const scroller = document.getElementById('pdfvuer')
      const currentPos = this.findPos(document.getElementById(p)) - firstPos - halfHeight
      const nextPos = document.getElementById(p + 1)
        ? this.findPos(document.getElementById(p + 1)) - firstPos - halfHeight
        : null
      if (this.page === this.numPages && scroller.scrollTop >= currentPos) {
        return
      } else if (scroller.scrollTop >= currentPos && nextPos !== null && scroller.scrollTop <= nextPos) {
        return
      }

      document.getElementById(this.page).scrollIntoView()
    },
    selPdfPath: function (pdfpath) {
      // 預留監聽點：目前無需額外處理
    }
  },
  created() {
    if (this.data.ID === undefined) return

    // 註冊事件處理器
    this.eventbus.$on('saveData', this.saveData)
    this.eventbus.$on('updateData', this.updateData)
    this.eventbus.$on('dialog:showFieldName', this.showFieldNameDialog)
    this.eventbus.$on('dialog:showrelationship', this.showRelationshipDialog)

    this.docData.ID = this.data.ID

    // 解析簽名資料
    if (this.data.SIGN_DATA !== null && this.data.SIGN_DATA !== '') {
      this.docData.SIGN_DATA = JSON.parse(this.data.SIGN_DATA)
    } else this.docData.SIGN_DATA = []
    this.docData.PATIENT_DATA = this.data.PATIENT_DATA

    // 寫入 localStorage 供其他組件使用（TransformBox、keyboard.js）
    // 注意：多實例可能互相覆蓋，但由於組件生命週期管理，通常不會同時存在多個實例
    // 理想情況下應該通過 props 或 eventbus 傳遞狀態，但為保持向後兼容暫時保留
    window.localStorage.setItem('isViewMode', String(this.isViewMode))
    this.setFieldsData(this.docData.SIGN_DATA)

    // 初始化PDF
    this.selPdfPath = this.data.TEMPLATE_PATH
    this.page = 1
    this.numPages = 0
    this.curLoadedPage = 0
    // 使用 loadPdfFromApi 載入 PDF（支援 API 端點和 Blob URL）
    this.loadPdfFromApi(this.selPdfPath)
  },
  beforeDestroy() {
    // 移除事件處理器
    this.eventbus.$off('saveData', this.saveData)
    this.eventbus.$off('updateData', this.updateData)
    this.eventbus.$off('dialog:showFieldName', this.showFieldNameDialog)
    this.eventbus.$off('dialog:showrelationship', this.showRelationshipDialog)
    // 釋放 Blob URL
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl)
      this.blobUrl = null
    }
  },
  methods: {
    // 設定簽名欄位資料
    setFieldsData(controls) {
      if (this.isAssign === false) return

      for (let i = 0; i < controls.length; i++) {
        if (controls[i].extra.usertype === 'Main Signer') {
          // 設定主要簽署者欄位資料
          if (controls[i].extra.fieldname === 'Name') controls[i].extra.value = this.docData.PATIENT_DATA.NAME
          else if (controls[i].extra.fieldname === 'MedicalRecordNo')
            controls[i].extra.value = this.docData.PATIENT_DATA.MEDICAL_RECORD_NO
          else if (controls[i].extra.fieldname === 'IDnumber')
            controls[i].extra.value = this.docData.PATIENT_DATA.ID_NUMBER
          else if (controls[i].extra.fieldname === 'Dateofbirth')
            controls[i].extra.value = this.docData.PATIENT_DATA.DATEOFBIRTH
          else if (controls[i].extra.fieldname === 'Address')
            controls[i].extra.value = this.docData.PATIENT_DATA.ADDRESS
          else if (controls[i].extra.fieldname === 'Phone') controls[i].extra.value = this.docData.PATIENT_DATA.PHONE
          else {
            if (controls[i].extra.type === 'sex') {
              controls[i].extra.value = this.docData.PATIENT_DATA.SEX
            }
          }
        } else if (controls[i].extra.usertype === 'Doctor') {
          // 設定醫生欄位資料
          if (controls[i].extra.fieldname === 'Name') controls[i].extra.value = this.USERNAME
        }

        if (controls[i].children) {
          this.setFieldsData(controls[i].children)
        }
      }
    },
    handleDeadlineChange(value) {
      // 預留 hook：目前無需額外處理
    },
    // 處理編輯器動作
    handleEditor(val) {
      if (val === 'under') {
        this.eventbus.$emit(EVENT_APPLICATION_UNDO)
      } else if (val === 'redo') {
        this.eventbus.$emit(EVENT_APPLICATION_REDO)
      } else if (val === 'duplicate') {
        this.eventbus.$emit(EVENT_COMPONENT_DUPLICATE)
      } else if (val === 'delete') {
        this.eventbus.$emit(EVENT_COMPONENT_DELETE)
      } else if (val === 'clear') {
        this.eventbus.$emit(EVENT_APPLICATION_CLEAR)
      }
    },
    // 從 API 端點載入 PDF（使用 axios + Blob URL）
    async loadPdfFromApi(path) {
      try {
        // 如果已經是 Blob URL，直接使用
        if (path && path.startsWith('blob:')) {
          this.pdfdata = PDF.createLoadingTask(path)
          // 等待組件掛載後再調用 getPdf
          this.$nextTick(() => {
            if (this.pdfdata) this.getPdf()
          })
          return
        }

        // 必須是新的 API 端點（/api/files/template/:id, /api/files/tobesigned/:id, /api/files/signed/:id）
        if (path && path.includes('/api/files/')) {
          // 使用 axios（已配置認證攔截器）請求 API
          const response = await request({
            url: path,
            method: 'get',
            responseType: 'blob' // 重要：指定 responseType 為 blob
          })

          // 創建 Blob URL（response.data 是 Blob 對象）
          this.blobUrl = URL.createObjectURL(response.data)

          // 傳給 vue-pdf
          this.pdfdata = PDF.createLoadingTask(this.blobUrl)

          // 等待組件掛載後再調用 getPdf
          this.$nextTick(() => {
            if (this.pdfdata) this.getPdf()
          })
        } else {
          throw new Error('不支援的 PDF 路徑格式，必須使用 /api/files/ 端點或 blob: URL')
        }
      } catch (error) {
        this.$message.error('PDF 載入失敗：' + (error.message || '未知錯誤'))
      }
    },
    // 顯示欄位名稱設定對話框
    showFieldNameDialog() {
      this.control.fieldname = ''
      this.fieldNameDialogVisible = true
    },
    // 處理欄位名稱設定
    handleSetFieldName() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$refs.vseditor.setFieldName(this.control.fieldname)
          this.fieldNameDialogVisible = false
        }
      })
    },
    // 顯示關係設定對話框
    showRelationshipDialog(item) {
      this.item = item
      this.relationshipDialogVisible = true
    },
    // 處理關係設定
    handleSetRelationship() {
      this.$refs.rformRef.validate((valid) => {
        if (valid) {
          this.item.extra.signername = this.control.signername
          this.item.extra.relationship = this.control.relationship
          this.relationshipDialogVisible = false
        }
      })
    },
    // 更新簽名資料
    updateData(controls) {
      this.docData.SIGN_DATA = controls
      this.refreshSignData(this.docData.SIGN_DATA)
      this.placeholderKey = +new Date()
    },
    // 載入PDF文檔
    async getPdf() {
      if (!this.selPdfPath || !this.selPdfPath.includes('/api/files/')) {
        this.$message.error('PDF 路徑格式錯誤，必須使用 /api/files/ 端點')
        return
      }

      let existingPdfBytes
      try {
        const response = await request({
          url: this.selPdfPath,
          method: 'get',
          responseType: 'blob'
        })

        existingPdfBytes = await response.data.arrayBuffer()
      } catch (error) {
        this.$message.error('PDF 載入失敗：' + (error.message || '未知錯誤'))
        return
      }
      const pdfDoc = await PDFDocument.load(existingPdfBytes)
      const pages = pdfDoc.getPages()
      const firstPage = pages[0]
      const { width, height } = firstPage.getSize()
      this.realpdfwidth = width
      this.realpdfheight = height

      // 計算顯示寬度
      const screenwidth = document.getElementById('topbar').clientWidth
      if (this.realpdfwidth * 1.5 > screenwidth) this.showpdfwidth = screenwidth
      else this.showpdfwidth = this.realpdfwidth * 1.5
      this.showpdfwidth = screenwidth

      const self = this

      // 處理PDF載入
      this.pdfdata.promise
        .then((pdfd) => {
          this.pdfdata._worker.destroy()
          self.numPages = pdfd.numPages

          // 監聽視窗大小變更
          const resizeObserver = new ResizeObserver(function () {
            setTimeout(() => {
              const screenwidth = document.getElementById('topbar').clientWidth
              if (self.realpdfwidth * 1.5 > screenwidth) self.showpdfwidth = screenwidth
              else self.showpdfwidth = self.realpdfwidth * 1.5
              self.showpdfwidth = screenwidth

              setTimeout(() => {
                const tempWidth = document.getElementById(1).clientWidth
                const pageHeight = document.getElementById(1).clientHeight
                // 計算包含頁面間距的總高度（最後一頁沒有 margin）
                const totalMargin = (self.numPages - 1) * self.PAGE_MARGIN
                const tempHeight = pageHeight * self.numPages + totalMargin

                if (tempWidth === 0 || tempHeight === 0) return
                if (self.pdfWidth === tempWidth) {
                  return
                }
                self.pdfWidth = tempWidth
                self.pdfHeight = tempHeight

                self.$refs.vseditor.handleUpdate()
              }, 1000)
            }, 1)
          })

          resizeObserver.observe(document.getElementById('topbar'))

          // 處理滾動事件
          document.getElementById('pdfvuer').onscroll = function () {
            changePage()
          }

          // 更新頁碼
          function changePage() {
            let i = 1
            const count = Number(pdfd.numPages)
            if (document.getElementById(1) === null) return
            const firstPos = self.findPos(document.getElementById(1))
            const halfHeight = document.getElementById(1).clientHeight / 2 - 50
            do {
              if (
                document.getElementById('pdfvuer').scrollTop >=
                  self.findPos(document.getElementById(i)) - firstPos - halfHeight &&
                document.getElementById('pdfvuer').scrollTop <=
                  self.findPos(document.getElementById(i + 1)) - firstPos - halfHeight
              ) {
                self.page = i
              }
              i++
            } while (i < count)
            if (
              document.getElementById('pdfvuer').scrollTop >=
              self.findPos(document.getElementById(i)) - firstPos - halfHeight
            ) {
              self.page = i
            }
          }
        })
        .catch((e) => {
          this.$message.error('PDF 解析失敗：' + (e.message || '未知錯誤'))
        })
    },
    // 取得元素位置
    findPos(obj) {
      if (obj === null) return 0
      return obj.offsetTop
    },
    error(err) {
      this.$message.error('PDF 載入時發生錯誤：' + ((err && err.message) || '未知錯誤'))
    },
    // 更新簽名資料位置與大小
    refreshSignData(controls) {
      for (let i = 0; i < controls.length; i++) {
        controls[i].transform.x = controls[i].extra.x * (this.pdfWidth / controls[i].extra.pdfWidth)
        controls[i].transform.y = controls[i].extra.y * (this.pdfHeight / controls[i].extra.pdfHeight)
        controls[i].transform.width = controls[i].extra.width * (this.pdfWidth / controls[i].extra.pdfWidth)
        controls[i].transform.height = controls[i].extra.height * (this.pdfHeight / controls[i].extra.pdfHeight)
        controls[i].grid = [1, 1]

        // 設定控制項狀態
        if (this.isAssign) {
          controls[i].extra.disabled = false
          controls[i].rotatable = false
          controls[i].resizable = false
          controls[i].draggable = false
        } else {
          controls[i].extra.disabled = true
          if (this.isViewMode) {
            controls[i].extra.disabled = false
            controls[i].rotatable = false
            controls[i].resizable = false
            controls[i].draggable = false
          } else {
            controls[i].rotatable = true
            controls[i].resizable = true
            controls[i].draggable = true
          }
        }

        if (controls[i].children) {
          this.refreshSignData(controls[i].children)
        }
      }
    },
    // 處理PDF頁面載入完成
    pageLoaded(pagenum) {
      this.curLoadedPage = pagenum
      if (pagenum === 1) {
        const tempWidth = document.getElementById(1).clientWidth
        const pageHeight = document.getElementById(1).clientHeight
        // 計算包含頁面間距的總高度（最後一頁沒有 margin）
        const totalMargin = (this.numPages - 1) * this.PAGE_MARGIN
        const tempHeight = pageHeight * this.numPages + totalMargin

        this.pdfWidth = tempWidth
        this.pdfHeight = tempHeight

        this.refreshSignData(this.docData.SIGN_DATA)
        this.placeholderKey = +new Date()
      }
      if (pagenum === this.numPages) {
        this.isLoadedPdf = true
        this.$emit('print')
      }
    },
    // 處理PDF連結點擊
    handle_pdf_link: function (params) {
      const page = document.getElementById(String(params.pageNumber))
      page.scrollIntoView()
    },
    handleBack() {
      this.$emit('back')
    },
    // 取得下載檔案名稱
    getFileName() {
      return (this.data.DOC_NAME || 'document') + '.pdf'
    },
    // 下載 PDF
    handleDownload() {
      if (!this.blobUrl) {
        this.$message.warning('PDF 尚未載入完成')
        return
      }
      const link = document.createElement('a')
      link.href = this.blobUrl
      link.download = this.getFileName()
      link.click()
    },
    // 列印 PDF
    handlePrint() {
      if (!this.blobUrl) {
        this.$message.warning('PDF 尚未載入完成')
        return
      }
      const printWindow = window.open(this.blobUrl)
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print()
        }
      }
    },
    handleSave() {
      this.$refs.vseditor.handleSave(this.docTreeData, this.docData)
    },
    // 儲存簽名資料
    saveChildData(controls) {
      for (let i = 0; i < controls.length; i++) {
        controls[i].extra.x = controls[i].transform.x
        controls[i].extra.y = controls[i].transform.y
        controls[i].extra.width = controls[i].transform.width
        controls[i].extra.height = controls[i].transform.height
        controls[i].extra.pdfWidth = this.pdfWidth
        controls[i].extra.pdfHeight = this.pdfHeight

        controls[i].rotatable = true
        controls[i].resizable = true
        controls[i].draggable = true
        if (controls[i].children) {
          this.saveChildData(controls[i].children)
        }
      }
    },
    // 儲存文檔
    saveData(controls) {
      this.docData.SIGN_DATA = controls
      this.isSaveData = true
      this.saveChildData(this.docData.SIGN_DATA)

      if (this.isAssign) {
        this.$emit(
          'assignDocument',
          JSON.stringify(this.docData.SIGN_DATA),
          this.parseTime(this.deadline_date1, '{y}-{m}-{d}'),
          this.deadline_days
        )
        return
      }

      const tempData = {}
      tempData.ID = this.docData.ID
      tempData.SIGN_DATA = JSON.stringify(this.docData.SIGN_DATA)

      updateDocHistory(tempData)
        .then((res) => {
          tempData.SIGNED_PDF_PATH = res.data
          this.isSaveData = false
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success',
            duration: 2000
          })
          this.$emit('updateDocHistory', tempData)
        })
        .catch(() => {
          this.isSaveData = false
        })
    },
    assignDocument() {
      this.handleSave()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/stylesForm/home.scss';
@import '@/styles/stylesForm/mixin.scss';

// PDF 容器基礎樣式
.pdf-container {
  background: white;
  width: 100%;
  height: 100%;

  &.in-dialog {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.el-dialog__body {
  padding: 0;
}

.right-preview {
  margin-right: 150px;
  margin-left: 0;
  box-sizing: border-box;
  position: relative;

  // 當有右側面板時，加強右側邊界區分
  &:not(.dialog-mode) {
    border-right: 1px solid #dcdfe6;
  }

  // Dialog 模式下的樣式調整
  &.dialog-mode {
    margin-right: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-right: none; // Dialog 模式下不需要右側邊界
  }

  @include action-bar;
  ::v-deep .el-drawer__header {
    display: none;
  }

  .action-bar {
    flex-shrink: 0;
    z-index: 10;
    background: #fff; // 70% 主色
    padding: 12px 16px;
    border: none !important; // 移除所有邊框（覆蓋 mixin 中的邊框）
    border-bottom: none !important; // 移除底部邊框

    // Dialog 模式下的優化
    .dialog-mode & {
      border-radius: 0;
      margin: 0;
    }

    // Header 按鈕樣式 - 使用綠色背景提高可見度
    .bar-btn {
      display: inline-flex; // 使用 flex 確保對齊
      align-items: center; // 垂直居中
      justify-content: center; // 水平居中
      padding: 0;
      margin-right: 8px; // 統一間距
      line-height: 1;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      user-select: none;
      transition: all 0.2s ease;
      min-width: 70px; // 統一最小寬度
      height: 32px; // 統一高度

      // 最後一個按鈕不需要右邊距
      &:last-child {
        margin-right: 0;
      }
    }

    .rect {
      background: #42b983 !important; // 10% 強調色（綠色背景），提高可見度
      color: #fff !important; // 白色文字，確保對比度
      padding: 8px 16px; // 統一 padding
      font-size: 12px;
      font-weight: normal !important; // 統一字體粗細，不使用粗體
      font-style: normal !important; // 移除斜體
      border: none; // 移除邊框
      border-radius: 4px;
      transition: all 0.2s ease;
      cursor: pointer;
      box-shadow: 0 1px 3px rgba(66, 185, 131, 0.3); // 使用綠色陰影
      display: inline-flex; // 使用 flex
      align-items: center; // 垂直居中
      justify-content: center; // 水平居中
      width: 100%; // 填滿父容器
      height: 100%; // 填滿父容器
      white-space: nowrap; // 防止文字換行
      gap: 6px;

      & i {
        color: #fff !important; // 圖標也使用白色
        font-style: normal !important; // 確保圖標不是斜體
      }

      &:hover {
        background: #42b983 !important;
        opacity: 0.9;
        box-shadow: 0 2px 6px rgba(66, 185, 131, 0.4); // hover 時加深陰影
      }
    }
  }

  .center-board {
    height: 75vh;
    width: auto;
    margin: 0;
    box-sizing: border-box;
    padding-top: 5px;
    position: relative;
    flex: 1;
    min-height: 0;

    // 當有右側面板時，加強右側邊界區分
    .right-preview:not(.dialog-mode) & {
      border-right: 1px solid #dcdfe6;
    }

    // Dialog 模式下的高度調整
    .dialog-mode & {
      height: calc(100% - 60px);
      max-height: calc(90vh - 120px);
      width: 100%;
      border-right: none; // Dialog 模式下不需要右側邊界
    }

    .top-pdf-bar {
      display: flex;
      background: #304156; // 20% 次要色（主題色）
      width: 100%;
      padding: 12px 16px;
      flex-shrink: 0;
      z-index: 5;
      box-shadow: 0 1px 4px rgba(48, 65, 86, 0.2);
      border-radius: 0;

      // Dialog 模式下的優化
      .dialog-mode & {
        border-radius: 0;
      }
    }

    #pdfContainer {
      position: relative;
      height: calc(100% - 50px);
      width: 100%;
      overflow: hidden;
      background: #f5f7fa;
      padding: 20px;
      box-sizing: border-box;
      border: 1px solid #e4e7ed; // 使用邊框線代替陰影

      // Dialog 模式下的優化
      .dialog-mode & {
        background: #f5f7fa;
        padding: 20px;
        border: 1px solid #e4e7ed; // 使用邊框線代替陰影
      }

      .result-wrapper {
        height: 100%;
        width: 100%;
        overflow: auto;
        padding: 0;
        box-sizing: border-box;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background: transparent;

        // 自定義滾動條樣式
        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        &::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.05);
          border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 4px;

          &:hover {
            background: rgba(0, 0, 0, 0.3);
          }
        }

        #pdfLayer {
          position: relative;
          width: 100%;
          max-width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;

          .pdf-view {
            width: 100%;
            max-width: 100%;
            display: inline-block;
            background: white;
            border: 1px solid #dcdfe6; // 使用邊框線代替陰影
            border-radius: 2px;
            margin-bottom: 16px;
            transition: border-color 0.2s ease;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); // 輕微陰影，僅用於層次感

            &:hover {
              border-color: #c0c4cc; // hover 時邊框稍微加深
            }

            &.last-page {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}

.right-board {
  width: 250px;
  position: absolute;
  right: 0;
  top: 0;
  padding-top: 8px;
  border-left: 1px solid #dcdfe6; // 使用邊框線作為左側邊界
  background: #fff; // 確保背景色一致

  // 統一美化 el-card 邊框
  ::v-deep .el-card {
    border: none;
    box-shadow: none !important; // 強制移除陰影
  }

  // 統一美化 el-tabs 邊框
  ::v-deep .el-tabs {
    border: none;

    .el-tabs__header {
      border-bottom: 1px solid #e4e7ed;
    }

    .el-tabs__item {
      border: none;
    }
  }

  // 移除右側面板內所有項目的陰影效果
  ::v-deep .vs-components {
    .components-item {
      box-shadow: none !important; // 強制移除項目陰影
    }
  }
}

.right-board-assign {
  width: 250px;
  position: absolute;
  right: 0;
  top: 0;
  padding-top: 70px;

  // 統一美化 el-card 邊框
  ::v-deep .el-card {
    border: none;
    box-shadow: none !important; // 強制移除陰影
  }

  // 移除右側面板內所有項目的陰影效果
  ::v-deep .vs-components {
    .components-item {
      box-shadow: none !important; // 強制移除項目陰影
    }
  }
}
</style>
